import React from 'react'
import { Button, Popconfirm, Space } from 'antd'
import { CopyOutlined, DeleteOutlined, EditOutlined, FileOutlined } from '@ant-design/icons'
import { ICellRendererParams } from 'ag-grid-enterprise'
import { useTranslation } from 'react-i18next'
import { Voucher, VoucherType } from '../../../../pages/reporting/vouchers/types'

const disabledVoucherTypes = [VoucherType.AUTO_CONS_MI, VoucherType.AUTO_CONS_ASSOC]

export interface VoucherActionsContext {
  editVoucher?: (voucher: Voucher) => void
  copyVoucher?: (voucher: Voucher) => void
  deleteVoucher?: (voucher: Voucher) => void
  openAttachments?: (voucher: Voucher) => void
}

interface VoucherActionsCellRendererParams extends ICellRendererParams<Voucher> {
  context: VoucherActionsContext
}

const VoucherActionsCellRenderer: React.FC<VoucherActionsCellRendererParams> = ({ data, context }) => {
  const { t } = useTranslation()

  if (!data) return null

  const { editVoucher, copyVoucher, deleteVoucher, openAttachments } = context
  const isVoucherDisabled = disabledVoucherTypes.includes(data.type)
  const hasAttachments = (data.attachments?.length || 0) > 0

  return (
    <Space>
      <Button
        style={{
          visibility: hasAttachments ? 'visible' : 'hidden'
        }}
        size="small"
        type="link"
        icon={<FileOutlined />}
        onClick={() => openAttachments?.(data)}
      />
      <Button
        size="small"
        type="link"
        icon={<EditOutlined />}
        onClick={() => editVoucher?.(data)}
        disabled={isVoucherDisabled}
      />
      <Button size="small" type="link" icon={<CopyOutlined />} onClick={() => copyVoucher?.(data)} />
      <Popconfirm
        disabled={isVoucherDisabled}
        placement="topRight"
        title={t('global:delete-confirm')}
        onConfirm={() => deleteVoucher?.(data)}
      >
        <Button danger size="small" type="link" icon={<DeleteOutlined />} disabled={isVoucherDisabled} />
      </Popconfirm>
    </Space>
  )
}

export default VoucherActionsCellRenderer
